import { useState } from 'react';
import { Dialog, Grid, Typography, IconButton, Box, Divider } from '@mui/material';
import Timeline from '@mui/lab/Timeline';
import TimelineItem from '@mui/lab/TimelineItem';
import TimelineSeparator from '@mui/lab/TimelineSeparator';
import TimelineConnector from '@mui/lab/TimelineConnector';
import TimelineContent from '@mui/lab/TimelineContent';
import TimelineOppositeContent from '@mui/lab/TimelineOppositeContent';
import TimelineDot from '@mui/lab/TimelineDot';
import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined';
import CloseIcon from '@mui/icons-material/Close';
import HistoryIcon from '@mui/icons-material/History';
import { locationHistoryType } from '../../redux-store/types/api-types';
import { formatShortDate } from '../../utils/date';
import { timeLineTime } from '../../utils/utilityFunctions';

export const UserHistoryDetailsDialog = ({
  activityLogData,
}: {
  activityLogData: locationHistoryType[];
}): JSX.Element => {
  const [dialogOpen, setDialogOpen] = useState(false);
  const handleClose = () => {
    setDialogOpen(false);
  };
  return (
    <Box>
      <IconButton onClick={() => setDialogOpen(true)}>
        <HistoryIcon
          fontSize="inherit"
          sx={{ color: 'primary.main', width: 'fit-content', fontSize: '48px' }}
        />
      </IconButton>
      <Dialog
        onClose={handleClose}
        open={dialogOpen}
        sx={{
          '.MuiPaper-root ': {
            p: 0,
            width: { xs: '70%', sm: '70%' },
          },
        }}>
        <Grid
          item
          container
          direction="row"
          justifyContent={{ xs: 'center', sm: 'end' }}
          flexWrap="nowrap"
          alignItems="center"
          p={4}
          pb={2}>
          <Typography
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              alignSelf: 'center',
              wordBreak: 'break-word',
              mr: { md: 18, xs: 4 },
              color: 'primary.main',
              fontSize: '28px',
              fontWeight: 500,
            }}>
            History Logs
          </Typography>
          <IconButton sx={{ alignSelf: 'end' }} onClick={handleClose}>
            <CloseIcon fontSize="medium" />
          </IconButton>
        </Grid>
        <Divider />
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            width: { xs: '100%', sm: '100%' },
            mx: 'auto',
            pl: 0,
            '.MuiTypography-root': {
              fontSize: 20,
              fontWeight: 500,
            },
          }}>
          <Timeline
            sx={{
              position: 'relative',
              left: { md: '-80px' },
            }}>
            {activityLogData.map((historyData, index) => (
              <TimelineItem key={index}>
                <TimelineOppositeContent
                  sx={{ m: 'auto 0', mt: index > 0 ? 6.5 : 1.5 }}
                  align="right"
                  variant="body2"
                  color="text.secondary">
                  {formatShortDate(historyData.createdAt)}
                  <Typography sx={{ fontSize: '14px !important' }}>
                    {timeLineTime(historyData.createdAt)}
                  </Typography>
                </TimelineOppositeContent>
                <TimelineSeparator>
                  {index > 0 && (
                    <TimelineConnector sx={{ bgcolor: '#22dedf', height: 40, width: 3 }} />
                  )}
                  <TimelineDot variant="outlined" sx={{ borderColor: '#22dedf', borderWidth: 4 }}>
                    <DescriptionOutlinedIcon
                      fontSize="large"
                      sx={{ fontSize: '50px', color: 'primary.main' }}
                    />
                  </TimelineDot>
                </TimelineSeparator>
                <TimelineContent>
                  <Typography
                    sx={{
                      color: 'text.secondary',
                      fontSize: '16px !important',
                      mt: index > 0 ? 6.5 : 1.5,
                    }}>
                    <Typography
                      sx={{ color: 'text.secondary', fontSize: '12px !important' }}></Typography>
                    By: {`${historyData.createdBy.firstName} (${historyData.createdBy.role})`}
                    <Typography sx={{ color: 'text.secondary', fontSize: '12px !important' }}>
                      {historyData.message}
                    </Typography>
                  </Typography>
                </TimelineContent>
              </TimelineItem>
            ))}
          </Timeline>
        </Box>
      </Dialog>
    </Box>
  );
};
